import { Box, Grid, Pagination } from "@mui/material";
import { set } from "date-fns";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";

import { getProperties } from "../../api/properties/getProperties";
import { prospectosGestion } from "../../cacheQueries/cacheQueries";
import TokenContext from "../../context/Token";
import LegalTable from "../../pages/legal/LegalTable";
import { defaultFilter } from "../GeneralFilter/defaultFilter";
import GeneralFilter from "../GeneralFilter/GeneralFilter";
import Loading from "../loading/Loading";

// import ProceedingCard from '../../components/Proceeding/ProceedingCard'

const GestionContainer = ({ setStatus }) => {
  const { token } = useContext(TokenContext);
  const [filters, setFilters] = useState({ ...defaultFilter });
  const [settlements, setSettlements] = useState([]);
  const [results] = useState(20);
  const [page, setPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState(1);

  const { isLoading, isError, data, refetch, isFetching } = useQuery(
    [prospectosGestion, token, results, page],
    () =>
      getProperties(token, results, page, "Gestion", "", "", {
        ...filters,
        dateStart: set(new Date(filters.dateStart), {
          hours: 0,
          minutes: 0,
          seconds: 0
        }).toISOString(),
        dateEnd: set(new Date(filters.dateEnd), {
          hours: 23,
          minutes: 59,
          seconds: 59
        }).toISOString()
      }),
    { refetchOnWindowFocus: false, keepPreviousData: true }
  );

  useEffect(() => {
    const getPaginationValue = () => {
      setPaginationValue(Math.ceil(data?.properties?.totalDocs / results));
    };

    getPaginationValue();
  }, [data?.properties?.totalDocs, results]);

  // if (isLoading) return <Loading />;

  if (isError) {
    return <h2>Error al cargar datos</h2>;
  }

  return (
    <Box display={"flex"} flexDirection={"column"} width={"100%"}>
      <Box
        mt={2}
        mb={11}
        height={32}
        display={"flex"}
        justifyContent={"center"}
      >
        {paginationValue > 0 && (
          <Pagination
            color="primary"
            count={paginationValue}
            page={page}
            onChange={(e, value) => setPage(value)}
          />
        )}
      </Box>
      <Box style={{ width: "100%", paddingLeft: "8px" }} display="flex">
        <GeneralFilter
          refetch={refetch}
          filters={filters}
          setFilters={setFilters}
          settlements={settlements}
          setSettlements={setSettlements}
        />
      </Box>
      {data?.properties.length === 0 ? (
        <h2 className="fs-5 margin-element">
          No se encontraron casas en Clientes
        </h2>
      ) : isFetching ? (
        <Grid
          container
          sx={{ flexGrow: 1 }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid item>
            <Loading />
          </Grid>
        </Grid>
      ) : (
        <LegalTable
          properties={data?.properties?.docs ?? []}
          refetch={refetch}
        />
      )}
    </Box>
  );
};

export default GestionContainer;
